module.exports = __webpack_public_path__ + "img/MySQL.c400a89.svg";